import { apiClient } from '../api-client';
import { REPORTS } from '../../api-endpoints/api-endpoints';
import { VolumeReport, CsatReport, SlaAttainmentReport, AgentProductivityReport } from '../../schema/reports/reports.schema';

export const reportsService = {
  volume: (from: string, to: string, groupBy: 'day' | 'week' | 'month' = 'day'): Promise<VolumeReport> =>
    apiClient.get<VolumeReport>(`${REPORTS.volume}?from=${from}&to=${to}&groupBy=${groupBy}`),

  csat: (from: string, to: string): Promise<CsatReport> =>
    apiClient.get<CsatReport>(`${REPORTS.csat}?from=${from}&to=${to}`),

  slaAttainment: (from: string, to: string): Promise<SlaAttainmentReport> =>
    apiClient.get<SlaAttainmentReport>(`${REPORTS.slaAttainment}?from=${from}&to=${to}`),

  agentProductivity: (from: string, to: string): Promise<AgentProductivityReport> =>
    apiClient.get<AgentProductivityReport>(`${REPORTS.agentProductivity}?from=${from}&to=${to}`),
};
